import isAuthenticationError from './is-authentication-error';
import { loginRequest, msalInstance } from '@/app/msal';

const getMicrosoftGraphAccessToken = async (): Promise<string> => {
  const activeAccount = msalInstance.getActiveAccount();

  if (!activeAccount) {
    return '';
  }

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: activeAccount,
    });

    return response.accessToken;
  } catch (error: unknown) {
    if (isAuthenticationError(error)) {
      return '';
    }

    throw error;
  }
};

export default getMicrosoftGraphAccessToken;
